<template>
  <div
    v-if="event?.title"
    class="flex flex-col"
  >
    <div class="order-0 bg-sand">
      <div class="container pt-5">
        <NuxtLink
          class="link-back-to link-green-darkest"
          :to="localePath('events')"
        >
          {{ $t('Back to') }} {{ $t('Events') }}
        </NuxtLink>
        <div class="grid-side-content grid gap-5 py-5 lg:pb-7 lg:pt-8">
          <div class="flex flex-col lg:py-2.5">
            <div class="space-y-3 md:space-y-5">
              <div class="font-semibold text-blue">
                {{ event.start_date }}
              </div>
              <h1 class="heading pb-0 text-green">
                {{ event.title }}
              </h1>
            </div>
          </div>
          <div class="prose mt-4 hidden max-w-full font-medium lg:block">
            <SofieText :value="event.text" />
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="event.active_image"
      class="relative order-1 md:order-2"
    >
      <div class="absolute inset-x-0 top-0 z-0 h-1/2 bg-sand" />
      <div class="container relative">
        <div class="grid-side-content">
          <div />
          <div class="col-start-5 col-end-13">
            <img
              :src="event?.active_image.url"
              :alt="event?.active_image?.alt"
              class="w-full object-cover md:max-h-96"
            >
          </div>
        </div>
        <div class="prose mt-4 block max-w-full font-medium lg:hidden">
          <p>
            {{ event.tekst }}
          </p>
        </div>
      </div>
    </div>
    <div class="container order-2 mb-10 lg:mb-20">
      <div class="grid-side-content grid gap-5 py-5 lg:pb-7 lg:pt-8">
        <h2 class="heading pb-5 text-green-darkest">
          {{ event.content_title }}
        </h2>
        <div class="prose max-w-full text-black">
          <SofieText :value="event.content_text" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {useEventQuery} from '~/graphql/graphql';

const localePath = useLocalePath();
const route = useRoute();

const {result} = await toAsyncQuery(useEventQuery({slug: route.params.slug}));

if (!result.value) {
  throw createError({statusCode: 404});
}
const event = computed(() => result.value!.event);
</script>
